<template>
<div id="mirrorHeader" class="mirrorHeader">
  <h1 class="mirrorHeader__title">{{ title }}</h1>
</div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.mirrorHeader {
  width: 100%;
  height: 80px;
  &__title {
    height: 80px;
    background-color: $base-black;
    color: $base-white;
    font-size: 36px;
    padding: 22px 0;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mirror/MirrorHeader.vue